export const REPORT_LISTING_HTML_CODE = `

    <!-- START: List reports code -->
    <div class="options-container">
        <div class="header">
            <div>Name</div>
        </div>
    </div>
    <!-- END: List reports code -->
    `;

export const REPORT_LISTING_JS_CODE = `

let initialReportId;

const replaceReport = (reportId, e) => {
    embedManagerPromise.then(embedManager => {
        const options = Array.from(document.getElementsByClassName('option'));
      
        if(e) {
            options.forEach(o => {
                o.classList.remove('selected');
                o.removeAttribute('disabled');
            });
            e.currentTarget.classList.add('selected');
            e.currentTarget.setAttribute('disabled', 'disabled');
        }
        createEmbedComponent(embedManager, { ...componentConfig, reportId });
    });
}

const getListOfReports = async () => {
    const reportsListUrl = '${process.env.REACT_APP_COMPOSER_URL}/api/dashboards';
    const { access_token } = await getToken();
    const headers = {
        'Accept': 'application/vnd.composer.v3+json',
        'Content-Type': 'application/vnd.composer.v3+json',
        'Authorization': 'Bearer ' + access_token
    }
    const response = await fetch(reportsListUrl, {headers});
    const data = await response.json();
    return (data.content || []).filter(d => d.isReportDashboard === true);

}

const addReportOption = (({id, name}) => {
    const optionsContainer = document.getElementsByClassName('options-container')[0];
    const reportButton = document.createElement('button');
    const reportNameDiv = document.createElement('div');
    const nameTextNode = document.createTextNode(name);

    reportButton.classList.add('option');
    reportNameDiv.classList.add('report-name');

    reportNameDiv.append(nameTextNode);
    reportButton.append(reportNameDiv);

	if (id === initialReportId) {
    	reportButton.classList.add('selected');
        reportButton.setAttribute('disabled', 'disabled');
    }

    reportButton.onclick = (e) => replaceReport(id, e);
    optionsContainer.append(reportButton);
})

const buildListOfReportsUi = async () => {
    const reportsList = await getListOfReports();
    initialReportId = reportsList[0].id;
    replaceReport(initialReportId);
    reportsList.forEach(v => addReportOption(v));
}

buildListOfReportsUi();
`;

export const REPORTS_LISTING_CSS_CODE = `

.options-container {
    width: 200px;
    padding-top: 28px;
    display: flex;
    flex-direction: column;
    overflow: auto;
}
  
.option, .header {
    width: 100%;
    padding: 5px 16px;
    display: flex;
    align-items: center;
}
  
.header {
    background: #f5f5f5;
    font-weight: 600;
    position: fixed;
    top: 0;
    font-size: 13px;
    color: #885a90;
}
  
.header-col {
    margin-right: 12px;
}
  
.option {
    width: 97%;
    padding: 5px 16px;
    background: #ffffff;
    border: none;
    cursor: pointer;
    margin: 3px 3px 0px 3px;
    border-radius: 5px;
}
  
.selected {
    background: #e8e8e8;
    cursor: default;
}
  
.option:not(.selected):hover {
    background: #f5f5f5;
}

.report-name {
    color: #4682B4;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
`;

export const REPORT_BUILDER_COMPONENT_CONFIG = `const componentConfig = {
    "theme":"%themeComposer%",%ipOverrides%
    "editor": { "placement": "%editorPlacement%" },
    "header": { 
        "showTitle": %showTitle%,
    }
}`;
